import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    loadClip,
    setClipData,
    resetClipData,
} from 'data/clip/clip-actions';
import { makeSelectClipData } from 'data/clip/clip-selectors';
import { selectConfig } from 'data/config/config-selectors';
import { makeSelectListItems } from 'data/list/list-selectors';
import {
    makeSelectTopicTitle,
    makeSelectTopicId,
    makeSelectTopicData,
} from 'data/topic/topic-selectors';
import PlaybackPage from './playback-page';
import { getPageData } from 'data/playback-page/playback-page-actions';
import { selectClientSideReady } from 'data/app/app-selectors';
import {
    makeSelectClub,
    makeSelectIsClubPage,
    makeSelectBasePath,
    makeSelectLang,
    makeSelectPlaybackPageDisplayAdConfig,
    makeSelectDeviceInfo,
    makeSelectDictionary,
    makeSelectMboxes,
} from 'data/config/runtime-config-selectors';

const mapStateToProps = createStructuredSelector({
    clipData: makeSelectClipData(),
    mediaConfig: selectConfig,
    clientSideReady: selectClientSideReady(),
    club: makeSelectClub(),
    isClubPage: makeSelectIsClubPage(),
    list: makeSelectListItems(),
    topicTitle: makeSelectTopicTitle(),
    topicId: makeSelectTopicId(),
    itemsBasePath: makeSelectBasePath(),
    topic: makeSelectTopicData(),
    lang: makeSelectLang(),
    displayAdConfig: makeSelectPlaybackPageDisplayAdConfig(),
    deviceInfo: makeSelectDeviceInfo(),
    dictionary: makeSelectDictionary(),
    mbox: makeSelectMboxes(),
});

export const mapDispatchToProps = (dispatch) => ({
    getClipData: (id) => dispatch(loadClip(id)),
    setClipData: (data) => dispatch(setClipData(data)),
    resetClipData: () => dispatch(resetClipData()),
    getPageData: (contentId, topicId) => dispatch(getPageData(contentId, topicId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PlaybackPage);
